import { Component, OnInit } from "@angular/core";
import { env } from "@environments/environment";
import { authConfig } from "@app/oauth/auth.config";
import { OAuthService } from "angular-oauth2-oidc";
import { MenuItem } from "primeng/api/menuitem";
import { Router } from "@angular/router";
import { BasketService } from "@app/components/basket/basket.service";
import { DataService } from "@app/services/data.service";
import { AccountService } from "@app/services/account.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  constructor(public oauthSvc: OAuthService,
              public accountService: AccountService,
              public basketService: BasketService,
              public dataService: DataService,
              private router: Router) {}
  eStockHomePage = env.eStockHomePage;
  items: MenuItem[] = [];

  ngOnInit(): void {
    this.items = [
      {
        label: "Вихід",
        icon: "pi pi-fw pi-power-off",
        command: () => {
          this.logout();
        },
      },
    ];
  }

  goToBasket(): void {
    if (this.basketService.basketItems.size > 0) {
      this.router.navigate(["/basket"]);
    }
  }

  logout() {
    authConfig.redirectUri = `${location.origin}${location.pathname}`;
    this.oauthSvc.redirectUri = `${location.origin}${location.pathname}`;
    this.oauthSvc.logOut();
  }
}
